import { render } from "./LayananView.vue?vue&type=template&id=4a94e454"
import script from "./LayananView.vue?vue&type=script&lang=js"
export * from "./LayananView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__